<template>
  <div>
    <b-modal id="seats-edit-modal" :title="item.name" :cancel-disabled="true">
      <label class="control control-checkbox">
        <input
          id="have-seat"
          v-model="tempItem.notHaveSeat"
          type="checkbox"
          @change="toggleHaveSeat"
        />
        {{ $t("dashboard.seats.edit.checkbox") }}
        <div class="control_indicator"></div>
      </label>

      <b-row class="my-3 mt-4 container-fitting">
        <b-col cols="6">
          <input
            type="number"
            v-model="tempItem.people_fitting"
            :placeholder="$t('dashboard.seats.edit.people-fitting') "
            :disabled="tempItem.notHaveSeat"
          />
        </b-col>
        <b-col cols="6">
          <input
            type="number"
            v-model="tempItem.stock"
            :placeholder="$t('dashboard.seats.edit.spots')"
            :disabled="tempItem.notHaveSeat"
          />
        </b-col>
      </b-row>

      <b-row class="my-3 w-100">
        <b-col>
          <input
            type="text"
            class="w-100"
            v-model="tempItem.description"
            :placeholder="$t('utils.description')"
            :disabled="tempItem.notHaveSeat"
          />
        </b-col>
      </b-row>

      <hr/>

      <b-row class="my-3 container-fitting">
        <b-col cols="6">
          <select
            v-model="tempItem.price_currency"
            :disabled="tempItem.notHaveSeat"
          >
            <option value="eur">EUR</option>
            <option value="gbp">GBP</option>
          </select>
        </b-col>
      </b-row>

      <b-row class="my-3 container-fitting">
        <b-col cols="6">
          <input
            type="number"
            v-model="tempItem.price_hour"
            :placeholder="$t('utils.table.price-hour')"
            :disabled="tempItem.notHaveSeat"
          />
        </b-col>
        <b-col cols="6">
          <input
            type="number"
            v-model="tempItem.price_day"
            :placeholder="$t('utils.table.price-day')"
            :disabled="tempItem.notHaveSeat"
          />
        </b-col>
      </b-row>

      <template #modal-footer>
        <button class="btn btn-primary" @click="save()" :disabled="canSave">
          {{ $t("utils.save") }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      tempItem: {
        id: "",
        name: "",
        description: "",
        price_hour: null,
        price_day: null,
        stock: null,
        people_fitting: null,
        price_currency: "eur",
        notHaveSeat: false,
        isNew: ""
      }
    };
  },
  mounted() {
    setTimeout(() => this.mapTempItem(), 0);
  },
  watch: {
    item: function(value) {
      this.item = value;
      this.mapTempItem();
    }
  },
  computed: {
   canSave() {
     if ((this.tempItem.description == null || this.tempItem.description === "" || this.tempItem.people_fitting === null || this.tempItem.people_fitting === "" || this.tempItem.stock === "" || this.tempItem.stock === null || this.tempItem.price_currency == null || (this.tempItem.price_hour == null && this.tempItem.price_day == null) || (this.tempItem.price_hour === "" && this.tempItem.price_day === "") || this.tempItem.price_day === "") && !this.tempItem.notHaveSeat) {
       return true
     } else {
       return false
     }
   }
  },
  methods: {
    save() {
      this.$emit("cliked", this.tempItem);
      this.$bvModal.hide("seats-edit-modal");
    },

    mapTempItem() {
      this.tempItem = {
        id: this.$props.item.id,
        name: this.$props.item.name,
        description: this.$props.item.description,
        stock: this.$props.item.stock,
        people_fitting: this.$props.item.people_fitting,
        type: this.$props.item.type,
        price_hour: this.$props.item.price_hour,
        price_day: this.$props.item.price_day,
        price_currency: this.$props.item.price_currency,
        notHaveSeat: this.$props.item.isNew,
        isNew: this.$props.item.isNew
      };
    },

    toggleHaveSeat() {
      if (this.tempItem.notHaveSeat) {
        this.tempItem.price_hour = null;
        this.tempItem.description = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/fonts";
@import "src/assets/scss/colors";
@import "src/assets/scss/buttons";

label {
  font-family: $inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}

input {
  border: 1.6px solid #000000;
  border-radius: 6px;
  font-family: $inter;
  padding: 0.5rem;

  &:focus {
    box-shadow: none;
  }
}

.container-fitting {
  input {
    width: 174px;
  }

  select {
    width: 174px;
  }
}

hr {
  width: 100%;
  border: 1px solid #000000;
}

select {
  width: 243px;
  height: 43px;
  border: 1.6px solid #000000;
  box-sizing: border-box;
  border-radius: 6px;
  font-family: $mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.3px;
  background-color: #ffffff;
  padding-left: 5px;

  &:focus {
    box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.075), 0 0 8px #7e4ee2;
    border: 2px solid #7e4ee2;
    box-sizing: border-box;
    border-radius: 6px;
  }

  &:hover {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px #7e4ee2;
    border: 2px solid #7e4ee2;
    box-sizing: border-box;
    border-radius: 6px;
  }
}

button {
  width: 140px;
  height: 34px;
}

.control {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-bottom: 0.5rem;
  padding-top: 0.2rem;
  cursor: pointer;
  font-family: $worksans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #000000;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;

    &:checked ~ .control_indicator:after {
      display: block;
    }

    &:checked ~ .control_indicator {
      background: $button-auth;
      opacity: 0.6;
      pointer-events: none;
    }
  }
}

.control_indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 22px;
  width: 22px;
  background: #fff;
  border: 2px solid #757575;
  box-sizing: border-box;
  border-radius: 3px;

  &:after {
    box-sizing: unset;
    content: "";
    position: absolute;
    display: none;
  }
}

.control-checkbox {
  .control_indicator:after {
    left: 7px;
    top: 4px;
    width: 3px;
    height: 7px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  input:disabled ~ .control_indicator:after {
    border-color: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/seats/SeatsEditModal.vue